import { createContext, useContext } from 'react';
import type { AuthUser, LoginInput } from '@/api/types';

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous';
export type SignOutReason = 'logout' | 'expired' | null;

export interface AuthContextValue {
  status: AuthStatus;
  user: AuthUser | null;
  /** Why the last session ended: a deliberate sign-out, or an expired/revoked session. */
  signOutReason: SignOutReason;
  login: (input: LoginInput) => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error('useAuth must be used inside <AuthProvider>');
  return value;
}
